import React, { useEffect, useMemo, useState } from "react";
import RecentlySearchedBlock from "./Generic/RecentlySearchedBlock";
import { cInfrastructures } from "@di";
import filter from "@domains/utils/filter";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import { getStockElement } from "./AllSearchDataBlock";
import { useNavigate } from "react-router-dom";
export const AddRecentSearchList = async (symbol) => {
    try {
        let searchList = await cInfrastructures.localStorage.get("recentSearch");
        let searchListJson = [];
        if (!!searchList && symbol) {
            searchListJson = JSON.parse(searchList);
            if (searchListJson.find((x) => x === symbol)) {
                return;
            }
            if (searchListJson.length >= 15) {
                searchListJson.splice(searchListJson.length - 1, 1);
            }
            searchListJson.unshift(symbol);
        }
        cInfrastructures.localStorage.set("recentSearch", JSON.stringify(searchListJson));
    }
    catch (error) { }
};
export const getRecentSearchList = async () => {
    try {
        const searchList = await cInfrastructures.localStorage.get("recentSearch");
        let searchListJson = [];
        if (searchList.length > 0) {
            searchListJson = JSON.parse(searchList);
            // const resList = await tocDi.tocJourney.getMultiQuote({
            //   symLst: searchListJson,
            // });
            return searchListJson;
        }
    }
    catch (error) {
        console.log(error, "error");
    }
};
export const RecentSearch = (props) => {
    const device = DeviceContext();
    const navigate = useNavigate();
    const localStorage = useMemo(() => cInfrastructures.localStorage, []);
    const [list, setList] = useState();
    const [edit, setEdit] = useState(false);
    const [loader, setLoader] = useState(false);
    const filterList = useMemo(() => {
        if (!!(props === null || props === void 0 ? void 0 : props.type) && list) {
            return filter(list, [{ key: "assetType", value: props === null || props === void 0 ? void 0 : props.type }]);
        }
        else
            return list;
    }, [list]);
    useEffect(() => {
        setList(props.list);
    }, [props.list]);
    console.log(filterList);
    const deleteSearchlist = async (symbol) => {
        try {
            setLoader(true);
            let searchList = await localStorage.get("recentSearch");
            let searchListJson = [];
            if (!!searchList) {
                searchListJson = JSON.parse(searchList);
                const index = searchListJson.findIndex((x) => x === symbol);
                const indexData = list.findIndex((x) => x.symbol === symbol);
                if (indexData >= 0) {
                    const newList = list;
                    newList.splice(indexData, 1);
                    setList(newList);
                }
                if (index >= 0) {
                    searchListJson.splice(index, 1);
                    localStorage.set("recentSearch", JSON.stringify(searchListJson));
                }
            }
            setLoader(false);
        }
        catch (error) { }
    };
    // const getStockElement = (data: ISearchQouteData) => {
    //   switch (data?.assetType) {
    //     case SearchAssetTypeEnum.Equity.toUpperCase():
    //       return (
    //         <SearchContentBlock
    //           topleft={
    //             <StockNameExchange
    //               stockName={data.dpNm}
    //               exchangeVal={data.exchange}
    //             />
    //           }
    //           topright={
    //             edit ? (
    //               <EdButton
    //                 btnTyp={"midnight-blue"}
    //                 type="button"
    //                 onClick={() => deleteSearchlist(data.symbol)}
    //                 value={"Delete"}
    //               />
    //             ) : (
    //               <>
    //                 <StockLtp reportVal={data.ltp} />
    //               </>
    //             )
    //           }
    //           bottomleft={<SubStockName stockName={data.description} />}
    //           bottomRight={
    //             edit ? (
    //               <></>
    //             ) : (
    //               <StockChange
    //                 change={data.change}
    //                 changePerc={data.changePerc}
    //               />
    //             )
    //           }
    //         />
    //       );
    //     case SearchAssetTypeEnum.Option:
    //       return (
    //         <SearchContentBlock
    //           topleft={<StockName stockName={data.dpNm} />}
    //           topright={
    //             <>
    //               <StockLtp reportVal={data.ltp} />
    //             </>
    //           }
    //           bottomleft={
    //             <StockNameExchange
    //               stockName={data.trdSym}
    //               exchangeVal={data.exchange}
    //             />
    //           }
    //           bottomRight={
    //             <StockChange change={data.change} changePerc={data.changePerc} />
    //           }
    //         />
    //       );
    //     case SearchAssetTypeEnum.Future:
    //       return (
    //         <SearchContentBlock
    //           topleft={<StockName stockName={data.dpNm} />}
    //           topright={
    //             <>
    //               <StockLtp reportVal={data.ltp} />
    //             </>
    //           }
    //           bottomleft={
    //             <StockNameExchange
    //               stockName={data.trdSym}
    //               exchangeVal={data.exchange}
    //             />
    //           }
    //           bottomRight={
    //             <StockChange change={data.change} changePerc={data.changePerc} />
    //           }
    //         />
    //       );
    //     case SearchAssetTypeEnum.MF:
    //       return (
    //         <SearchContentBlock
    //           topleft={<StockName stockName={data.dpNm} />}
    //           topright={
    //             <>
    //               <StockYears stockYear={"3"} stock={"cagr"} reportVal={"345"} />
    //             </>
    //           }
    //           bottomleft={
    //             <StockswithDot stockName={"Equity"} subStockName={"LargeCap"} />
    //           }
    //           bottomRight={<StockStar Rating={"7"} />}
    //         />
    //       );
    //     case SearchAssetTypeEnum.PrimaryMarket:
    //       return (
    //         <StockPrimaryMarketBlock
    //           stockName={"One 97 Communications Ltd"}
    //           marketStats={"live Now"}
    //           marketClose={"22-3-4-4"}
    //           subscriptionAmount={"333"}
    //           closeTime={"3333"}
    //           minInv="6767"
    //           onSelected={undefined}
    //           onApply={undefined}
    //         />
    //       );
    //     case SearchAssetTypeEnum.SGB:
    //       return (
    //         <>
    //           {device?.isDesktop ? (
    //             <StocksSgbBlock
    //               MainStock={"2021-22 SERIES IX"}
    //               dateIssuance={"08-Mar-22"}
    //               interestRate={"343"}
    //               startDate={"22-sep-23"}
    //               endDate={"34-feb-23"}
    //               price={"4745"}
    //               minLimit={4}
    //               maxLimit={7}
    //               onSelected={undefined}
    //             />
    //           ) : (
    //             <StocksSgbMobileBlock
    //               MainStock={"2021-22 SERIES IX"}
    //               dateIssuance={"08-Mar-22"}
    //               interestRate={"343"}
    //               startDate={"22-sep-23"}
    //               endDate={"34-feb-23"}
    //               price={"4745"}
    //               minLimit={4}
    //               maxLimit={7}
    //             />
    //           )}
    //         </>
    //       );
    //     case SearchAssetTypeEnum.CORPFD:
    //       return (
    //         <StocksCorpFd
    //           stockName={"Kintech Renewables Ltd OFS"}
    //           Rating={"556"}
    //           intRate={"4.56"}
    //           onSelected={undefined}
    //         />
    //       );
    //     case SearchAssetTypeEnum.Commodity:
    //       return (
    //         <SearchContentBlock
    //           topleft={<StockName stockName={"BankNifty"} />}
    //           topright={
    //             <>
    //               <StockLtp reportVal={"567"} />
    //             </>
    //           }
    //           bottomleft={
    //             <StockNameExchange stockName={"Tata"} exchangeVal={"NSE"} />
    //           }
    //           bottomRight={<StockChange change={"678"} changePerc={"78"} />}
    //         />
    //       );
    //     case SearchAssetTypeEnum.Currency:
    //       return (
    //         <SearchContentBlock
    //           topleft={<StockName stockName={"BankNifty"} />}
    //           topright={
    //             <>
    //               <StockLtp reportVal={"567"} />
    //             </>
    //           }
    //           bottomleft={
    //             <StockNameExchange stockName={"Tata"} exchangeVal={"NSE"} />
    //           }
    //           bottomRight={<StockChange change={"678"} changePerc={"78"} />}
    //         />
    //       );
    //     case SearchAssetTypeEnum.ETFs:
    //       return (
    //         <SearchContentBlock
    //           topleft={
    //             <StockNameExchange stockName={"Tata"} exchangeVal={"NSE"} />
    //           }
    //           topright={
    //             <>
    //               <StockLtp reportVal={"567"} />
    //             </>
    //           }
    //           bottomleft={<SubStockName stockName={"Tata Chemicals"} />}
    //           bottomRight={<StockChange change={"678"} changePerc={"78"} />}
    //         />
    //       );
    //     case SearchAssetTypeEnum.Indices:
    //       return (
    //         <SearchContentBlock
    //           topleft={
    //             <StockNameExchange stockName={"Tata"} exchangeVal={"NSE"} />
    //           }
    //           topright={
    //             <>
    //               <StockLtp reportVal={"567"} />
    //             </>
    //           }
    //           bottomleft={<SubStockName stockName={"Tata Chemicals"} />}
    //           bottomRight={<StockChange change={"678"} changePerc={"78"} />}
    //         />
    //       );
    //     case SearchAssetTypeEnum.NcdSecondary:
    //       return (
    //         <StocksNcdBlock
    //           MainStock={
    //             "Edelweiss Finance & Investment limited - 9.25% -  10 Feb 2032"
    //           }
    //           yearReturns={"17.62"}
    //           maturityDate={"22-sep-2023"}
    //           invAmount={"10,000"}
    //           btnText={"Invest"}
    //           frequency={"Annual"}
    //           rate={"4.78"}
    //           bondRating=""
    //           onSelected={undefined}
    //           onApply={undefined}
    //         />
    //       );
    //     case SearchAssetTypeEnum.OptionChain:
    //       return <></>;
    //     default:
    //       return <></>;
    //   }
    // };
    return (React.createElement("div", null, (filterList === null || filterList === void 0 ? void 0 : filterList.length) > 0 && (React.createElement(React.Fragment, null,
        React.createElement(RecentlySearchedBlock, { stockCount: filterList.length, content: React.createElement(React.Fragment, null, !loader &&
                filterList.map((x) => {
                    // return getStockElement(x);
                    return getStockElement(x, navigate, props.closePopup, props.setShowToc, props.setSymbol, edit, (symbol) => deleteSearchlist(symbol), props.setShowMFToc);
                })), setEdit: setEdit })))));
};
